import { Button } from 'primereact/button';
import { cn } from '@/components/ui/cn';
import { TextHeadlineLarge } from '@/components/text/Texts';
import { Dialog } from 'primereact/dialog';
import { MdClose } from 'react-icons/md';
import { useForm } from 'react-hook-form';
import { object, string } from 'yup';
import { VALIDATION_MESSAGES } from '@/constants/validation';
import { yupResolver } from '@hookform/resolvers/yup';
import ResizeTextArea from '@/components/form-inputs/ResizeTextArea';
import { createTypedModal, useTypedModal } from '@/common/common_utils';

export type TextAreaModalProps = {
	title: string;
	label: string;
	value?: string;
};

const TextAreaModal = createTypedModal<TextAreaModalProps, string | undefined>(({ title, label, value = '' }: TextAreaModalProps) => {
	const modal = useTypedModal<string | undefined>();

	const formName = 'TextAreaModal';
	const form = useForm({
		defaultValues: { textareaValue: value },
		resolver: yupResolver(object({
			textareaValue: string().trim().required(VALIDATION_MESSAGES.required)
		})),
	});

	const isValid = form.formState.isValid;

	return (
		<Dialog
			unstyled
			visible={true}
			closable={false}
			onHide={()=>{}}
			maskStyle={{ backgroundColor: '#00000047' }}
			pt={{ content: { className: cn('flex flex-col w-[544px] tablet:!max-w-[calc(100vw-6rem)] px-8 pb-10 pt-[52px] rounded-[28px] bg-surfaceContainer relative')}}}
		>
			<button
				onClick={() => modal.resolveRemove()}
				className="absolute top-6 right-6 rounded-full p-1 transition duration-200 hover:bg-gray-300"
				children={(<MdClose size={24} className="text-onSurfaceVariant"/>)}
			/>

			<TextHeadlineLarge className="mb-10 text-neutral17" text={title} />

			<ResizeTextArea
				id="textareaValue"
				label={label}
				formName={formName}
				control={form.control}
				containerClassName="mb-6"
			/>

			<Button
				label="Add"
				disabled={!isValid}
				onClick={form.handleSubmit((data) => modal.resolveRemove(data.textareaValue))}
				pt={{
					root: { className: cn('px-8 py-4 rounded-[100px] self-end', isValid ? 'bg-primary' : 'bg-[#D2D5D7]') },
					label: { className: cn('font-poppins text-label-large2', isValid ? 'text-white' : 'text-[#7D7F80]') },
				}}
			/>
		</Dialog>
	);
});

export default TextAreaModal;
